import styles from "./SectionTitle.module.css";

export function SectionTitle({ text = "ABOUT ME", num = "01" }) {
  return (
    <>
      <div className={styles.container}>
        <span>{num + " |"}</span>
        <h2>{text}</h2>
      </div>
    </>
  );
}
